import {
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	Stack,
	Typography,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import { useCallback, useState } from "react";
import { Thread } from "../../../types/data";
import { AddRecipients } from "./AddRecipients";
import { UserChip } from "./UserChip";

type Props = {
	thread: Thread;
};

export function Recipients({ thread }: Props) {
	const [showAllRecipients, setShowAllRecipients] = useState(false);

	const openPopup = useCallback(() => {
		setShowAllRecipients(true);
	}, []);

	const closePopup = useCallback(() => {
		setShowAllRecipients(false);
	}, []);

	return (
		<Stack
			direction="row"
			sx={{
				flexWrap: "wrap",
				alignItems: "center",
				gap: "8px",
			}}
		>
			<Typography
				sx={{
					fontWeight: 400,
					fontSize: 12,
					color: "#0000004D",
					mr: "10px",
				}}
			>
				Visible to:{" "}
			</Typography>
			{thread.groups.slice(0, 1).map((group) => (
				<Chip key={group} label={group} color="primary" />
			))}
			{thread.receiver_ids.slice(0, 1).map((email) => (
				<Chip key={email} label={email} />
			))}
			<Button variant="text" onClick={openPopup}>
				View All / Edit
			</Button>
			<Dialog open={showAllRecipients} onClose={closePopup}>
				<DialogTitle>Manage Participants</DialogTitle>
				<DialogContent>
					<Stack
						direction="row"
						sx={{
							flexWrap: "wrap",
							alignItems: "center",
							gap: "8px",
						}}
					>
						{thread.groups.map((group) => (
							<Chip key={group} label={group} color="primary" />
						))}
						{thread.receiver_ids.map((email) => (
							<UserChip key={email} thread={thread} email={email} />
						))}
						<AddRecipients thread={thread} />
					</Stack>
				</DialogContent>
			</Dialog>
		</Stack>
	);
}
